import Gayan from "./images/Gayan.jpg";
import McMaster from "./images/McMaster Logo.png";
import Rocketry from "./images/McMaster Rocketry Logo.jpg";
import TechM from "./images/Tech Mahindra Logo.jpg";
import IBM from "./images/IBM Logo.png";
import Tesla from "./images/Tesla Logo.png";
import JS from "./images/JavaScript Logo.png";
import Python from "./images/Python Logo.png";
import ReactLogo from "./images/React Logo.png";
import HtmlLogo from "./images/HTML Logo.png";
import JavaLogo from "./images/Java Logo.png";
import SQLLogo from "./images/SQL Logo.png";
import NodeLogo from "./images/NodeLogo.png";
import CSSLogo from "./images/CSS Logo.png";
import GmailLogo from "./images/Gmail Logo.png";
import LinkedInLogo from "./images/LinkedIn Logo.png";
import ZoomLogo from "./images/Zoom Logo.png";
import TeamsLogo from "./images/Teams Logo.png";
import GitHubIcon from "./images/GitHub Icon.png";
import LinkedInIcon from "./images/Linkedin Icon.png";
import OntarioHealth from "./images/Ontario Health Logo.png";
import Scotiabank from "./images/Scotiabank Logo.jpg";
import DeltaHacks from "./images/DeltaHacks Logo.png";
import LocalLove from "./images/LocalLove.png";
import ZeroFoodWaste from "./images/ZeroFoodWaste.png";
import Verses from "./images/Verses.png";
import IslandGen from "./images/IslandGen.svg";
import "./App.css";
import "./About.css";
import "./Projects.css";
import React, { useEffect, useState, useRef, useContext } from "react";
import Popup from "reactjs-popup";
import "reactjs-popup/dist/index.css";
import Project from "./Componenets/Project";
import Experience from "./Componenets/Experience";

function App() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const ScotiabankExperience = document.getElementById("Scotiabank");
  const OntarioHealthExperience = document.getElementById("OntarioHealth");
  const DeltaHacksExperience = document.getElementById("DeltaHacks");
  const TechMahindraExperience = document.getElementById("TechMahindra");
  const RocketryExperience = document.getElementById("Rocketry");
  const allBtn = document.getElementById("allBtn");
  const clubBtn = document.getElementById("clubBtn");
  const coopBtn = document.getElementById("coopBtn");

  const allButtonClick = () => {
    const TeslaExperience = document.getElementById("Tesla");
    const IBMExperience = document.getElementById("IBM");
    const ScotiabankExperience = document.getElementById("Scotiabank");
    const OntarioHealthExperience = document.getElementById("OntarioHealth");
    const DeltaHacksExperience = document.getElementById("DeltaHacks");
    const TechMahindraExperience = document.getElementById("TechMahindra");
    const RocketryExperience = document.getElementById("Rocketry");
    const allBtn = document.getElementById("allBtn");
    const clubBtn = document.getElementById("clubBtn");
    const coopBtn = document.getElementById("coopBtn");

    TeslaExperience.style.display = "flex";
    IBMExperience.style.display = "flex";

    ScotiabankExperience.style.display = "flex";

    TechMahindraExperience.style.display = "flex";

    OntarioHealthExperience.style.display = "flex";

    DeltaHacksExperience.style.display = "flex";

    RocketryExperience.style.display = "flex";

    allBtn.style.clipPath = "polygon(0 0, 100% 0, 100% 100%, 0% 100%)";
    allBtn.style.width = "17rem";
    allBtn.style.clipPath = "polygon(0 0, 94.5% 0, 100% 100%, 5.5% 100%)";
    clubBtn.style.width = "12rem";
    clubBtn.style.clipPath = "polygon(0 0, 92% 0, 100% 100%, 0 100%)";
    coopBtn.style.width = "12rem";
    coopBtn.style.clipPath = "polygon(0 0, 100% 0, 100% 100%, 8% 100%)";
    allBtn.style.backgroundColor = "#916FFF";
    coopBtn.style.backgroundColor = "#7848c4";
    clubBtn.style.backgroundColor = "#7848c4";
  };

  const clubButtonClick = () => {
    const TeslaExperience = document.getElementById("Tesla");
    const IBMExperience = document.getElementById("IBM");
    const ScotiabankExperience = document.getElementById("Scotiabank");
    const OntarioHealthExperience = document.getElementById("OntarioHealth");
    const DeltaHacksExperience = document.getElementById("DeltaHacks");
    const TechMahindraExperience = document.getElementById("TechMahindra");
    const RocketryExperience = document.getElementById("Rocketry");
    const allBtn = document.getElementById("allBtn");
    const clubBtn = document.getElementById("clubBtn");
    const coopBtn = document.getElementById("coopBtn");
    // setExperienceToggle(0);

    IBMExperience.style.display = "none";
    TeslaExperience.style.display = "none";

    ScotiabankExperience.style.display = "none";

    TechMahindraExperience.style.display = "none";

    OntarioHealthExperience.style.display = "none";

    DeltaHacksExperience.style.display = "flex";

    RocketryExperience.style.display = "flex";

    allBtn.style.width = "12rem";
    allBtn.style.clipPath = "polygon(0 0, 92% 0, 100% 100%, 8% 100%)";
    clubBtn.style.width = "17rem";
    clubBtn.style.clipPath = "polygon(0 0, 94.5% 0, 100% 100%, 0 100%)";
    coopBtn.style.width = "12rem";
    coopBtn.style.clipPath = "polygon(0 0, 100% 0, 100% 100%, 8% 100%)";
    allBtn.style.backgroundColor = "#7848c4";
    coopBtn.style.backgroundColor = "#7848c4";
    clubBtn.style.backgroundColor = "#916FFF";
  };

  const coopButtonClick = () => {
    const TeslaExperience = document.getElementById("Tesla");
    const IBMExperience = document.getElementById("IBM");
    const ScotiabankExperience = document.getElementById("Scotiabank");
    const OntarioHealthExperience = document.getElementById("OntarioHealth");
    const DeltaHacksExperience = document.getElementById("DeltaHacks");
    const TechMahindraExperience = document.getElementById("TechMahindra");
    const RocketryExperience = document.getElementById("Rocketry");
    const allBtn = document.getElementById("allBtn");
    const clubBtn = document.getElementById("clubBtn");
    const coopBtn = document.getElementById("coopBtn");
    // setExperienceToggle(2);
    ScotiabankExperience.style.display = "flex";

    TechMahindraExperience.style.display = "flex";

    OntarioHealthExperience.style.display = "flex";

    IBMExperience.style.display = "flex";

    TeslaExperience.style.display = "flex";

    DeltaHacksExperience.style.display = "none";

    RocketryExperience.style.display = "none";

    allBtn.style.width = "12rem";
    allBtn.style.clipPath = "polygon(0 0, 92% 0, 100% 100%, 8% 100%)";
    clubBtn.style.width = "12rem";
    clubBtn.style.clipPath = "polygon(0 0, 92% 0, 100% 100%, 0 100%)";
    coopBtn.style.width = "17rem";
    coopBtn.style.clipPath = "polygon(0 0, 100% 0, 100% 100%, 5.5% 100%)";
    allBtn.style.backgroundColor = "#7848c4";
    coopBtn.style.backgroundColor = "#916FFF";
    clubBtn.style.backgroundColor = "#7848c4";
  };

  const onSubmit = async (event) => {
    setEmail("");
    setMessage("");
    setName("");
    event.preventDefault();
    const formData = new FormData(event.target);

    formData.append("access_key", "f71b698f-2fa5-46ba-8b8c-8a3b0e025259");

    const object = Object.fromEntries(formData);
    const json = JSON.stringify(object);

    const res = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: json,
    }).then((res) => res.json());

    if (res.success) {
      console.log("Success", res);
    }
  };

  return (
    <div className="overlay">
      <div className="nav">
        <div className="intro">
          Hi<span className="name">!</span> &nbsp; My Name is Gayan Athukorala
          <span className="name">.</span>
        </div>
        <div className="menu-links">
          <a
            href="https://www.linkedin.com/in/gayanathukorala/"
            target="_blank"
          >
            <img className="linkedin-icon" src={LinkedInIcon} />
          </a>
          <a href="https://github.com/GayanAthukorala " target="_blank">
            <img className="github-icon" src={GitHubIcon} />
          </a>
        </div>
      </div>
      <div className="menu">
        <div className="menu-items-wrapper">
          <div id="menu-items">
            {/* <div id="bar" /> */}
            <div className="row">
              <a href="#about" className="menu-item">
                ABOUT
                <img className="about-1" src={McMaster} />
                <img className="about-2" src={Tesla} />
                <img className="about-3" src={IBM} />
                <img className="about-4" src={DeltaHacks} />
              </a>

              <div className="bar-wrapper">
                <div className="bar-peg" />
              </div>
            </div>
            <div className="swapY">
              {/* <div> */}
              <div className="row">
                <span className="swapY">
                  <a href="#contact" className="menu-item-2">
                    CONTACT
                    <img className="contact-1" src={LinkedInLogo} />
                    <img className="contact-2" src={TeamsLogo} />
                    <img className="contact-3" src={ZoomLogo} />
                    <img className="contact-4" src={GmailLogo} />
                  </a>
                </span>

                <div className="bar-wrapper">
                  <div className="bar-peg" />
                </div>
              </div>

              <div className="row">
                <span className="swapY">
                  <a href="#projects" className="menu-item-2">
                    PROJECTS
                    <img className="project-4" src={JS} />
                    <img className="project-2" src={Python} />
                    <img className="project-3" src={ReactLogo} />
                    <img className="project-1" src={HtmlLogo} />
                    <img className="project-8" src={NodeLogo} />
                    <img className="project-7" src={SQLLogo} />
                    <img className="project-6" src={JavaLogo} />
                    <img className="project-5" src={CSSLogo} />
                  </a>
                </span>

                <div className="bar-wrapper">
                  <div className="bar-peg" />
                </div>
              </div>
              {/* </div> */}
            </div>
          </div>
        </div>
        <div className="pictures-wrapper">
          {/* <div className="image-cropper"> */}
          <img src={Gayan} class="image-cropper" />
          {/* </div> */}
          {/* <div className="blurb-wrapper"> */}
          {/* <div className="blurb">
              Software Engineering&nbsp; <span className="name">@</span>{" "}
              McMaster
            </div> */}
          {/* </div> */}
        </div>
      </div>
      {/* <span className="lower-menu">
        <div className="menu-button-wrapper">
          <a href={Resume} type="application/pdf" target="_blank">
            <button className="menu-button">Resume</button>
          </a>
          <button
            className="menu-button"
            onClick={() =>
              window.open("https://github.com/GayanAthukorala", "_blank")
            }
          >
            GitHub
          </button>
        </div>
        <div className="blurb-wrapper">
          <div className="blurb">
            Software Engineering&nbsp; <span className="name">@</span> McMaster
          </div>
        </div>
      </span> */}
      <div id="about">
        <div className="about-title">
          ABOUT
          <span className="name">.</span>
        </div>
        <div className="about-info">
          <div className="about-paragraph">
            I'm a senior studying software engineering at McMaster University.
            I've always loved coming up with unique solutions to problems I
            faced in my life, and technology & software allow me to turn my
            ideas into a reality.
          </div>
          <div className="about-paragraph">
            My previous internships at companies such as Tesla, IBM, and
            Scotiabank have given me the opportunity to work in areas such as
            Cloud, Security, AI, and Full-Stack Development, where I've built
            production software with millions of dollars in impact. Outside of
            class I help organize one of Canada's biggest hackathons and enjoy
            playing a ton of volleyball!{" "}
          </div>
          <div className="about-toggle">
            <button className="club-btn" id="clubBtn" onClick={clubButtonClick}>
              {" "}
              Leadership Experience{" "}
            </button>
            <button className="all-btn" id="allBtn" onClick={allButtonClick}>
              {" "}
              All Experience
            </button>
            <button className="coop-btn" id="coopBtn" onClick={coopButtonClick}>
              {" "}
              Work Experience{" "}
            </button>
          </div>
          <div className="about-experience-wrapper">
            <Experience
              id="Tesla"
              picture={Tesla}
              company="Tesla"
              role="Software Engineer Intern "
            />
            <Experience
              id="IBM"
              picture={IBM}
              company="IBM"
              role="Software Developer Intern "
            />
            <Experience
              id="Scotiabank"
              picture={Scotiabank}
              company="Scotiabank"
              role="Software Engineer
                    Intern "
            />

            <Experience
              id="OntarioHealth"
              picture={OntarioHealth}
              company="Ontario Health"
              role="Software Developer Intern "
            />
            <Experience
              id="DeltaHacks"
              picture={DeltaHacks}
              company="DeltaHacks"
              role="VP Sponsorship "
            />

            <Experience
              id="TechMahindra"
              picture={TechM}
              company="Tech Mahindra"
              role="Jr. Software Engineer "
            />

            <Experience
              id="Rocketry"
              picture={Rocketry}
              company="McMaster Rocketry Team"
              role="Payload Subteam "
            />
          </div>
        </div>
      </div>
      <div id="projects">
        <div className="about-title">
          PROJECTS<span className="name">.</span>
        </div>
        <div className="projects-info">
          <div className="projects-background">
            <Project
              link="https://github.com/GayanAthukorala/LocalLove-DeltaHacks9"
              name="Local Love"
              picture={LocalLove}
              description="Find Local Businesses in your Area"
            />
            <Project
              link="https://github.com/GayanAthukorala/ZeroFoodWaste"
              name="ZeroFoodWaste"
              picture={ZeroFoodWaste}
              description="Learn Recipes with Personalized Ingredient Amounts to
                    Eliminate Food Wastage"
            />
            <Project
              link="https://github.com/GayanAthukorala/Verses-Hack-Western-9"
              name="Verses"
              picture={Verses}
              description="A music quiz app for you to test yourself and your friends
                    on your music taste"
            />

            <Project
              link="https://github.com/GayanAthukorala/Island-Generator"
              name="Island Generator"
              picture={IslandGen}
              description="Randomly generate islands with 15 customizable
                    features"
            />
          </div>
        </div>
      </div>
      <div id="contact">
        <div className="about-title">
          CONTACT<span className="name">.</span>
        </div>
        <div className="contact-blurb">
          Lets connect<span className="name">,&nbsp;</span> I would love to have
          a coffee chat<span className="name">!</span>{" "}
        </div>
        <form onSubmit={onSubmit}>
          <div className="contact-your-info-wrap"></div>
          <textarea
            name="message"
            className="contact-message"
            placeholder="Message"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          ></textarea>

          <div className="contact-button-container">
            <button type="submit" className="contact-button">
              Send
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default App;
